import { render, staticRenderFns } from "./GetDiagnostics.vue?vue&type=template&id=2cf944a4&"
import script from "./GetDiagnostics.vue?vue&type=script&lang=js&"
export * from "./GetDiagnostics.vue?vue&type=script&lang=js&"
import style0 from "./GetDiagnostics.vue?vue&type=style&index=0&id=2cf944a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports